import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CuttedMaterialPanel } from '../../models/cutting/cutting-cutted-material-panel.model';

import { CuttingPanel } from '../../models/cutting/cutting-panel.model';

@Component({
  selector: 'csl-panels-schema-dialog',
  templateUrl: './panels-schema-dialog.component.html',
  styleUrls: ['./panels-schema-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PanelsSchemaDialogComponent implements OnInit {
  @Input() data: { materialId: number; panels: CuttedMaterialPanel[]; selectedPanelUuid: string };

  @Input() linkToSchemas = '';

  constructor(
    public dialogRef: MatDialogRef<PanelsSchemaDialogComponent> //
  ) {}

  ngOnInit(): void {}
}
